import React, { useEffect, useState } from "react";
import { lifestyleApi } from "../apiService/api";

const DoctorHomeCard = () => {
  const [apiResponse, setApiResponse] = useState({});
  const [consent, setConsent] = useState("");

  useEffect(() => {
    lifestyleApi.fetchDermaDoctor()
      .then((res) => {
        setApiResponse(res.data.data);
        setConsent(res.data.data.consent);
      })
      .catch((err) => console.error("fetchDermaDoctor:", err));
  }, []);

  if (consent !== "Yes") return null;

  return (
    <section className="doctor-card">
      <img
        src={apiResponse.imageUrl || "https://appcdn.goqii.com/storeimg/64522_1711436754.jpg"}
        className="doctor-avatar"
        alt="doctor"
      />
      <div className="doctor-info">
        <h1 className="doctor-name">
          {apiResponse.doctorName} <span>ID {apiResponse.doctorId}</span>
        </h1>
        <hr className="doctor-divider" />
        <h3 className="doctor-expertise-label">Areas of Expertise</h3>
        <p className="doctor-degree">{apiResponse.degree}</p>
      </div>
    </section>
  );
};

export default DoctorHomeCard;
